import React from "react"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { Control } from "react-hook-form"
import FormDetailHeader from "./FormDetailHeader"
import BasicInputs from "./BasicInputs/BasicInputs"

type Props = {
  name: string
  eventId: string
  showUpgradeAlert: boolean
  control: Control
  sendConfirmationEmails: boolean
}

const Survey = ({
  name, eventId, showUpgradeAlert, control, sendConfirmationEmails,
}: Props) => (
  <>
    <FormDetailHeader
      name={name}
      description="Distributed via Diobox Emails, this form generates a unique link for each guest, ensuring responses are tracked and answers can be submitted only once."
    />
    {showUpgradeAlert && <UpgradeAlert mb={8} maxW="full" text="Requires Corporate Plan or higher" />}
    <BasicInputs
      control={control}
      eventId={eventId}
      sendConfirmationEmails={sendConfirmationEmails}
    />
  </>
)

export default Survey
